import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PageLoader from '../PageLoader/PageLoader';
import { getResourcePage, getAdvancedFunctionsCollection } from '../../../content/resources/metadata';
import { withCampaign } from '../../../libs/helpers/analytics';
import { trackEvent } from '../../../redux/analytics/analytics.reducer';

export function captureCourseFrame(doc) {
    const root = doc?.getElementById('root');
    const path = root?.getAttribute('data-course-frame');
    const page = getResourcePage(path);
    const collection = page?.kind === 'lesson' && getAdvancedFunctionsCollection(page.resource?.courseId);
    const pathname = doc?.location?.pathname.replace(/\/$/, '');
    const content = root?.querySelector('.page');
    if (!collection || page.path !== path || pathname !== path || !content) return null;
    return {
        path,
        courseId: page.resource.courseId,
        slug: path.slice('/lessons/'.length),
        collection,
        markup: content.innerHTML,
    };
}

// The build supplies the same pending course frame. Capture it before React
// mounts so downloading the route chunk keeps this useful, stable first view.
const initialFrame = captureCourseFrame(document);

export default function CoursePageLoader({ frame = initialFrame }) {
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const path = pathname.replace(/\/$/, '');
    if (frame?.path === path) {
        const handleClick = (event) => {
            const link = event.target.closest('a');
            if (!link || !event.currentTarget.contains(link)
                || !link.closest('[aria-labelledby="selected-practice-heading"]')) return;
            let clicked;
            try { clicked = new URL(link.href); } catch (_) { return; }
            if (clicked.username || clicked.password) return;
            const lesson = frame.collection.lessons.find((entry) => {
                const trusted = new URL(frame.collection.lessonUrl(entry.id));
                return clicked.origin === trusted.origin && clicked.pathname === trusted.pathname;
            });
            if (!lesson) return;
            // Rebuild from the verified URL so arbitrary link queries cannot
            // travel with the safe landing campaign. Native navigation stays intact.
            link.href = withCampaign(frame.collection.lessonUrl(lesson.id));
            dispatch(trackEvent({
                name: 'lesson_opened',
                params: {
                    course_id: frame.courseId,
                    course_slug: frame.slug,
                    topic_id: lesson.id,
                    lesson_type: 'interactive',
                    placement: 'selected_pathway',
                },
            }));
        };
        return <div className="page" onClick={handleClick} dangerouslySetInnerHTML={{ __html: frame.markup }} />;
    }
    return <PageLoader />;
}
